import { sendEvent } from 'clients/event_relay'
import { PageVisitedEvent } from './page_visited_event'
import { RewardsPageVisitedEvent } from './rewards_page_visited_event'

export default function ({ props } = { props: {} }) {
  if (props.pageType == 'rewards_tab') {
    sendEvent(
      RewardsPageVisitedEvent.type,
      new RewardsPageVisitedEvent({
        pageType: props.pageType,
        klasses: props.klasses,
      }).toObject(),
    )
  }
  else {
    sendEvent(
      PageVisitedEvent.type,
      new PageVisitedEvent({
        pageType: props.pageType,
        klass: props.klass,
      }).toObject(),
    )
  }
  return {}
}
